export enum HttpRoutes {
	WindcavePayment = '/payment/windcave/hpp/session',
	GuestPageConfiguration = '/backoffice/payment/guest-page/configuration',
	RequestCar = '/partner/guest/request-car',
	CancelRequest = '/partner/guest/cancel-request',
	GetPaymentDetail = '/partner/guest/payment/get-detail',
	PayTicket = '/partner/guest/payment/pay-ticket',
	FreedompayInit = '/payment/freedompay/hpc/init',
	FreedompaySubmit = '/payment/freedompay/hpc/submit',
}
